
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-keyboard-demo-plugin-keyboard"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.zh.md?type=demo')
};